import React, { useEffect, useState } from 'react';
import { SETTING_TABS_LABEL } from '../../constants/enum';
import ProfileIcon from '../../images/icons/profile.svg';
import SecurityIcon from '../../images/icons/security-icon.svg';
import WrenchIcon from '../../images/icons/wrench-icon.svg';
import WrenchIconGrey from '../../images/icons/wrench-icon-grey.svg';
import InformationCircleIcon from '../../images/icons/information-circle.svg';
import CurrencyPreference from './CurrencyPreference';
import CompanyDetails from './CompanyDetails';
import '../../styles/pages/setting-tabs.scss';
import LegalScaleIcon from '../../images/icons/legal-scale.svg';
import LightFlashOn from '../../images/icons/light-flash-on.svg';
import '../../styles/pages/profile.scss';
import { useLocation } from '@reach/router';

export default function SettingTabs() {
  return (
    <>
      <div className="setting-sso-on-content-container">
        <div className="md:-ml-6">
          <CurrencyPreference />
        </div>
        <div className="md:-ml-6 mt-6">
          <CompanyDetails />
        </div>
      </div>
    </>
  );
}
